<div [class.drag-active]="isDragging" class="app-container">
<ze-top-nav-component *ngIf="showHeader"></ze-top-nav-component>
<main class="app-router-host">
<router-outlet></router-outlet>
</main>
<ze-progress-spinner class="example-margin" [color]="color" [mode]="mode" [value]="value" [backdropEnabled]="true"
    [positionGloballyCenter]="true" [displayProgressSpinner]="displayProgressSpinner">
</ze-progress-spinner>
<ng-snotify></ng-snotify>
<ze-base-overlay-form [formConfig]="formConfig"></ze-base-overlay-form>
<ze-read-only-badge></ze-read-only-badge>
</div>